import { Box, BoxProps } from "@chakra-ui/react"

import { BORDER_RADIUS } from "../../constants"

type ProgressBarProps = {
  progress: number
} & BoxProps

const ProgressBar = ({ progress, ...boxProps }: ProgressBarProps) => {
  return (
    <Box
      className="PathProgressBar"
      w="full"
      h="full"
      borderRadius={BORDER_RADIUS}
      bg="whiteAlpha.600"
      {...boxProps}
    >
      <Box
        h="1em"
        w={`${progress * 100}%`}
        borderRadius={BORDER_RADIUS}
        bg="brand.500"
      />
    </Box>
  )
}

export default ProgressBar
